import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import VeeValidate from "./plugins/VeeValidate"
import VueApexCharts from "./plugins/VueApexCharts"
import VueCamVision from "./plugins/VueCamVision"
import Convert from "./plugins/Convert"
import VueQuillEditor from "./plugins/VueQuillEditor"
import VueGoogleMaps from "./plugins/VueGoogleMaps"
import VueSignaturePad from "./plugins/VueSignaturePad"

import '@/assets/css/main.css'
import '@/assets/css/main.scss'

import { TokenService } from "@/service/Storage.Service.js"

if (TokenService.getToken()) {
  store.commit("setToken", TokenService.getToken())
  store.commit("setUser", JSON.parse(TokenService.getUser()))
}

const patient = localStorage.getItem('patient')
if (patient) {
  store.commit("setPatient", JSON.parse(patient))
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  Convert,
  VeeValidate,
  VueQuillEditor,
  VueCamVision,
  VueApexCharts,
  VueGoogleMaps,
  VueSignaturePad,
  render: h => h(App)
}).$mount('#app')
